import { Input } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { AlignLeftOutlined } from "@/icons"
import { Form } from "../.."
import { Rules } from "../../helpers"
import { SectionFormTemplate } from "../SectionFormTemplate"

import type { DetailsSectionFormProps } from "."

const sectionId = "details-section-form"

export const DetailsSectionForm = (props: DetailsSectionFormProps) => {
  const { t } = useTranslation()
  const rules = [Rules.getRequiredFieldRule(t)]
  const desc = "forms.fields.description"
  const {
    children,
    prefix,
    suffix,
    disabled,
    title = t("general.details")
  } = props
  const { custom } = Form.useForm()
  const nameRules = [...rules, ...(props.nameRules || [])]

  return (
    <SectionFormTemplate id={sectionId} title={title} Icon={AlignLeftOutlined}>
      {prefix}
      <Form.Item
        required={false}
        name="name_details"
        label={props.label}
        rules={nameRules}
      >
        <Input
          disabled={disabled}
          ref={custom.focusRef}
          placeholder={t("forms.fields.name.placeholder")}
        />
      </Form.Item>
      {children}
      {!props.noDescription && (
        <Form.Item
          required={false}
          name="description_details"
          label={t(`${desc}.label`)}
        >
          <Input disabled={disabled} placeholder={t(`${desc}.placeholder`)} />
        </Form.Item>
      )}
      {suffix}
    </SectionFormTemplate>
  )
}

DetailsSectionForm.sectionId = sectionId
